import { render, staticRenderFns } from "./JuridicPerson.vue?vue&type=template&id=73fbb292"
import script from "./JuridicPerson.vue?vue&type=script&lang=js"
export * from "./JuridicPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports